import React from 'react'
import { TextInput } from 'react-admin'
import { EditGuesser } from 'theme/components'

export const SurgeryTypeOptionEdit = (props) => (
  <EditGuesser {...props} undoable={false} variant="outlined" redirect="list">
    <TextInput source="name" />
    <TextInput source="slug" />
  </EditGuesser>
)
